import { GroupList } from '../models/group-list.model';

export const mockGroup: GroupList = {
  groups: [
    {
      id: '0a669-b0af4',
      name: 'Group 1',
      status: 'Active',
      create_date: '2023-05-15',
      description: 'This is a description for group 1.',
      totalMembers: 8,
      accessLevel: 'Public',
      coverImage: 'https://dummyimage.com/820x312/000/fff&text=Image',
      avatar: './../../../../assets/images/friends-11.png',
      admins: [
        {
          id: '1b672-c1bg5',
          name: 'John Doe',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '2c673-d2ch6',
          name: 'Jane Smith',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        }
      ],
      members: [
        {
          id: '3d674-e3di7',
          name: 'Alice Johnson',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '4e675-f4ej8',
          name: 'Bob Thompson',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '5f676-g5fk9',
          name: 'Alex Telex',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        }
      ]
    },
    {
      id: '9j680-k9jo3',
      name: 'Group 2',
      status: 'Active',
      create_date: '2021-11-17',
      description: 'This is description group for group 2.',
      totalMembers: 4,
      accessLevel: 'Private',
      coverImage: 'https://dummyimage.com/820x312/000/fff&text=Image',
      avatar: './../../../../assets/images/group-avatar.jpg',
      admins: [
        {
          id: '0k681-l9kp4',
          name: 'Mark Johnson',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '1j682-m8jq5',
          name: 'Emily Wilson',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        }
      ],
      members: [
        {
          id: '2i683-n7ir6',
          name: 'Michael Smith',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '3h684-o6hs7',
          name: 'Jessica Davis',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        }
      ]
    },
    {
      id: '9j680-k9jo4',
      name: 'Group 3',
      status: 'Active',
      create_date: '2021-11-17',
      description: 'This is description group for group 2.',
      totalMembers: 4,
      accessLevel: 'Private',
      coverImage: 'https://dummyimage.com/820x312/000/fff&text=Image',
      avatar: './../../../../assets/images/friends-10.png',
      admins: [
        {
          id: '0k681-l9kp4',
          name: 'Mark Johnson',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '1j682-m8jq5',
          name: 'Emily Wilson',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        }
      ],
      members: [
        {
          id: '2i683-n7ir6',
          name: 'Michael Smith',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '3h684-o6hs7',
          name: 'Jessica Davis',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        }
      ]
    },
    {
      id: '9j680-k9jo5',
      name: 'Group 4',
      status: 'Active',
      create_date: '2021-11-17',
      description: 'This is description group for group 2.',
      totalMembers: 3,
      accessLevel: 'Private',
      coverImage: 'https://dummyimage.com/820x312/000/fff&text=Image',
      avatar: './../../../../assets/images/friends-9.png',
      admins: [
        {
          id: '0k681-l9kp4',
          name: 'Mark Johnson',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '1j682-m8jq5',
          name: 'Emily Wilson',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        }
      ],
      members: [
        {
          id: '2i683-n7ir6',
          name: 'Michael Smith',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '3h684-o6hs7',
          name: 'Jessica Davis',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        },
        {
          id: '3h684-o6hs5',
          name: 'Jessica Join',
          avatar: 'https://dummyimage.com/180x180/000/fff&text=Image'
        }
      ]
    }
  ]
};
